import React from 'react';
import Presenter from './Presenter';

const Container = () => {
  return <Presenter />;
};

export default Container;
